import { IntercomCreateModel } from '../model/intercomModel';
import { PayloadIntercomCreateModel } from '../model/intercomPayloadModel';

export const intercomToCreatePayload = ({ name, vendor, projectId }: IntercomCreateModel): PayloadIntercomCreateModel => {
  return { name, vendor, project_id: projectId };
};
